export default __webpack_public_path__ + "static/data-more-about-img--mobile-7da140b47d9befd6372fff595585c33f.webp";